import { render, staticRenderFns } from "./newScriptManagementThree.vue?vue&type=template&id=36c9789a&scoped=true"
import script from "./newScriptManagementThree.vue?vue&type=script&lang=js"
export * from "./newScriptManagementThree.vue?vue&type=script&lang=js"
import style0 from "./newScriptManagementThree.vue?vue&type=style&index=0&id=36c9789a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9789a",
  null
  
)

export default component.exports